import React, {useState} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import '../main.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../modal";

const InfraZone = ({createValet, infraZoneRes = null}) => {

    const [count, setCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false);
    const [inputList, setInputList] = useState([{
        project_id: '', name: ''
    }]);
    const [projectIdValidation, setProjectIdValidation] = useState("")
    const [nameValidation, setNameValidation] = useState("")
    const [inputName, setInputName] = useState([{name:''}])

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    const handleAddName = () => {
        setInputName(
            [
                ...inputName, {
                name: ''
                }
            ]
        )
    }

    const handleRemoveName = (index) => {
        const list = [...inputName];
        list.splice(index, 1);
        setInputName(list);
    }

    const handleNameInputValue = (val, index) => {
        let list = [...inputName];
        list[index]['name'] = val
        setInputName([...list])
    }

    const handleOnSubmitForm = async () => {
        let inputValues = inputList[0]
        let name = inputName
        setProjectIdValidation("")
        setNameValidation("")
        if (inputValues.project_id === "") {
            setProjectIdValidation("Project id is required")
        }


        if (inputValues.project_id !== '') {
            setIsLoading(true)
            await createValet(inputValues.project_id, name);
            setIsLoading(false)
            setCount(count + 1)
        }
    }

    return (
        <>
            <Layout isGoback isLoading={isLoading}>
                <div className="container-fluid">
                    <div className="card">
                        {infraZoneRes !== null && infraZoneRes.response.status !== 200 &&
                            <CustomModal msg={infraZoneRes.response.message} click={count}/>}
                        {infraZoneRes !== null && infraZoneRes.response.status === 200 &&
                            <CustomModal msg={infraZoneRes.response.message} isPageLoad={true} click={count}/>}
                        <div className="card-header">
                            {localization.zone}
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="validation">{projectIdValidation}</div>
                                    <ConstantInput
                                        label={localization.projectId}
                                        type="number"
                                        value={inputList.project_id}
                                        handleChange={(val) => {
                                            handleInputValue(val, 'project_id', 0);
                                        }} F
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <div className="validation">{nameValidation}</div>
                                    {inputName.map((x,i) => {
                                        return (
                                            <>
                                                <div className="col-md-4">
                                                    <ConstantInput
                                                        label={localization.name}
                                                        type="text"
                                                        value={x?.name}
                                                        handleChange={(val) => {
                                                            handleNameInputValue(val, i);
                                                        }}
                                                        required
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className="btn-box mb-4">
                                                    {inputName.length !== 1 &&
                                                        <button
                                                            onClick={() => handleRemoveName(i)}
                                                            className="btn btn-sm btn-danger mr10">Remove
                                                        </button>}
                                                    {inputName.length - 1 === i &&
                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            onClick={() => handleAddName()}>Add
                                                        </button>}
                                                </div>
                                            </>
                                        )
                                    })}
                                </div>
                                <div className="col-md-12">
                                    <center><Button onClick={handleOnSubmitForm}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>);
};
export default InfraZone
